
import sidebars from '~/mixins/sidebars';

export default {
  mixins: [sidebars],
  props: [],
  data() {
    return {
      showSidebar: false,
    }
  },
  methods: {
    open() {
      if (this.showSidebar) return;
      this.abrufen();
      this.openSidebar();
    },
    abrufen() {
      this.$$abrufen('app/tickets')
    },
  },
  mounted() {
    this.$nuxt.$on('display-tickets', this.open);
  },
  beforeDestroy() {
    this.$nuxt.$off('display-tickets', this.open);
  },
}
